// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"463":"b8619560","513":"f3f11976","959":"694263aa"}[chunkId] + ".chunk.css";
};